module.exports = __webpack_public_path__ + "img/V8.6b255e61.jpg";